import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { components } from 'react-select';
import clsx from 'clsx';
import styles from './Dropdown.module.scss.js';

var DropdownSingleValue = function (_a) {
    var children = _a.children, data = _a.data, props = __rest(_a, ["children", "data"]);
    return (React__default.createElement(components.SingleValue, __assign({ className: clsx(data.rightLabel && styles.Dropdown_singleValue), data: data }, props),
        children,
        data.rightLabel));
};
DropdownSingleValue.displayName = 'DropdownSingleValue';

export { DropdownSingleValue as default };
